import { useCallback, useEffect } from "react";

import { userBelongsToCompany } from "utils";

import { useAuthContext } from "./useAuthContext";
import { useSwrFetch } from "./useSwrFetch";

export function useUserChatInfo() {
  const { isAuthenticated, user, refreshChatTokens } = useAuthContext();

  const {
    data: chatInfo,
    loading,
    mutate: refreshChatInfo,
  } = useSwrFetch<UserChatInfo>({
    url:
      user && isAuthenticated && userBelongsToCompany(user)
        ? "/user/chat"
        : null,
    errorMessage: "Failed to fetch chat information",
  });

  useEffect(() => {
    refreshChatTokens();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refreshTokens = useCallback(
    (onRefreshSuccess?: () => void) => {
      if (onRefreshSuccess) {
        refreshChatTokens(onRefreshSuccess);
      } else {
        refreshChatTokens();
      }
    },
    [refreshChatTokens],
  );

  return {
    chatInfo,
    loading,
    refreshChatInfo,
    refreshChatTokens: refreshTokens,
  };
}
